export const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:4000';
export const SITE_URL = import.meta.env.VITE_SITE_URL || 'http://localhost:3000';

// For relative API URLs (e.g. "/api"), derive WS from the current page host.
// For absolute URLs (e.g. "http://localhost:4000"), swap the protocol.
function deriveWsBase(apiBase: string): string {
  if (apiBase.startsWith('http')) {
    return apiBase.replace(/^http/, 'ws');
  }
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${apiBase}`;
}

export const WS_BASE = deriveWsBase(API_BASE);
